import { gql } from "@apollo/client";

import { HOMEPAGE_CLIP_FIELDS_NEW } from "./homepage";

/**
 * Latest clips made with the in-game !allstar command, for the feed on
 * /!allstar. Unlike the homepage row this is not narrowed to the Allstar
 * in-game partner account: the page is about the command itself, so it shows
 * what everyone is making with it.
 */
export const ALLSTAR_COMMAND_FEED = gql`
  ${HOMEPAGE_CLIP_FIELDS_NEW}

  query AllstarCommandFeed($limit: Int) {
    clips: clipsNew(
      first: $limit
      filters: { clipProperties: [{ key: "CS_Command", value: "!allstar" }] }
      sort: LATEST
    ) {
      nodes {
        ...HomepageClipFieldsNew
      }
    }
  }
`;
